// import React, { useEffect, useRef, useState } from 'react';
// import { FaSearch, FaTimes } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { openSearch, closeSearch, selectIsSearchOpen } from '../redux/headerSlice';
// import './SearchModal.css';

// // Search data mapping
// const searchData = [
//   // Services
//   { term: 'Services', path: '/services' },
//   { term: 'CSC services', path: '/services' },
  
//   // ERP
//   { term: 'ERP services', path: '/services-erp' },
//   { term: 'IITD ERP', path: '/services-erp' },
  
//   // Docker
//   { term: 'Docker', path: '/home-docker' },
//   { term: 'Docker Service', path: '/home-docker' },
  
//   // Complaints
//   { term: 'Complain', path: '/services-miscellaneous-complaint' },
//   { term: 'Complaint', path: '/services-miscellaneous-complaint' },
  
//   // Discussion Forum
//   { term: 'Discussion Forum', path: '/services-miscellaneous-discussion-forum' },
//   { term: 'IITD Discussion Forum', path: '/services-miscellaneous-discussion-forum' },
  
//   // Scientific Software
//   { term: 'Ansys', path: '/services-software-scientific' },
//   { term: 'Intel', path: '/services-software-scientific' },
//   { term: 'PGI', path: '/services-software-scientific' },
//   { term: 'LabVIEW', path: '/services-software-scientific' },
//   { term: 'Materials Studio', path: '/services-software-scientific' },
//   { term: 'Compilers', path: '/services-software-scientific' },
//   { term: 'Compiler', path: '/services-software-scientific' },
//   { term: 'Intel Compiler', path: '/services-software-scientific' },
//   { term: 'PGI Compiler', path: '/services-software-scientific' },
//   { term: 'Abaqus', path: '/services-software-scientific' },
  
//   // Downloads
//   { term: 'Download Ansys', path: '/services-software-scientific' },
//   { term: 'Download Intel', path: '/services-software-scientific' },
//   { term: 'Download PGI', path: '/services-software-scientific' },
//   { term: 'Download COMSOL', path: '/services-software-scientific' },
//   { term: 'Download LabVIEW', path: '/services-software-scientific' },
//   { term: 'Download Materials Studio', path: '/services-software-scientific' },
//   { term: 'Download Compilers', path: '/services-software-scientific' },
//   { term: 'Download Compiler', path: '/services-software-scientific' },
//   { term: 'Download Intel Compiler', path: '/services-software-scientific' },
//   { term: 'Download PGI Compiler', path: '/services-software-scientific' },
//   { term: 'Download Abaqus', path: '/services-software-scientific' },
//   { term: 'Download Software', path: '/services-software-scientific' },
//   { term: 'Linux Software', path: '/services-software-scientific' },
  
//   // Network
//   { term: 'Eduroam', path: '/services-network-eduroam' },
//   { term: 'Campus Wi-Fi', path: '/services-network-wifi' },
//   { term: 'Campus WiFi', path: '/services-network-wifi' },
//   { term: 'Certificates', path: '/services-network-certificates' },
  
//   // Miscellaneous
//   // { term: 'Download Server', path: '/services-miscellaneous-download-server' },
//   { term: 'IITD Download Server', path: '/services-miscellaneous-download-server' },
//   { term: 'Email Client Configuration', path: '/services-network-email-client-config' },
//   { term: 'Email Mailing List', path: '/services-web-services-mailing' },
//   { term: 'Mailing List', path: '/services-web-services-mailing' },
//   { term: 'Email Technology', path: '/services-network-email-client-config' },
//   { term: 'Email', path: '/services-network-email-client-config' },
//   { term: 'Email Roundcube', path: '/services-user-admin-roundcube-webmail' },
//   { term: 'Grammarly', path: '/services-miscellaneous-grammarly' },
//   { term: 'Home cifs', path: '/services-software-network-home-spaces-cisf' },
//   { term: 'Wiki', path: '/services-miscellaneous-iitd-wiki' },
//   { term: 'Proxy', path: '/iitd-proxy' },
//   { term: 'IITD Proxy', path: '/iitd-proxy' },
//   { term: 'LAN', path: '/services-network-lan' },
//   { term: 'Wireless Linux', path: '/services-network-lan' },
//   { term: 'Software Linux', path: '/services-software-linux-centos' },
//   { term: 'Debian', path: '/services-software-linux-debian' },
//   { term: 'linux OS', path: '/services-software-linux' },
//   { term: 'Ubuntu', path: '/services-software-linux-ubuntu' },
//   { term: 'Moodle', path: '/services-miscellaneous-moodle' },
//   { term: 'Networking Policy', path: '/services-network-policy' },
//   { term: 'SSH Tunnel', path: '/services-miscellaneous-download-server' },
//   { term: 'Open Ports', path: '/services-miscellaneous-download-server' },
//   { term: 'WiFi Mac', path: '/services-network-wifi-mac' },
//   { term: 'Wi-Fi Mac', path: '/services-network-wifi-mac' },
//   { term: 'WiFi Windows', path: '/services-software-windows-os' },
//   { term: 'Wi-Fi Windows', path: '/services-software-windows-os' },
//   { term: 'NTP', path: '/services-network-ntp' },
//   { term: 'NTP server', path: '/services-network-ntp' },
//   { term: 'Overleaf', path: '/services-miscellaneous-overleaf' },
//   { term: 'Owncloud', path: '/services-miscellaneous-owncloud' },
//   { term: 'Password Reset Policy', path: '/services-miscellaneous-policies-password-reset' },
//   { term: 'Policies', path: '/services-miscellaneous-policies' },
//   { term: 'Internet Access Policy', path: '/services-miscellaneous-policies' },
//   { term: 'Usage Policy', path: '/services-miscellaneous-policies-usage' },
//   { term: 'Recruitment', path: '/services-miscellaneous-recruitment' },
//   { term: 'MATLAB', path: '/services-software-scientific' },
//   { term: 'SVN', path: '/services-software-network-svn' },
//   { term: 'VPN', path: '/setup-vpn' },
//   { term: 'Lost Password', path: '/services-user-admin-forgot-password' },
//   { term: 'Account Suspended', path: '/services-user-admin-suspension' },
//   { term: 'New Account Password services', path: '/services-user-admin-getting-password-for-new-user' },
//   { term: 'Creation of Users for Workshop', path: '/services-user-admin-infra' },
//   { term: 'Creation of Users for Conference', path: '/services-user-admin-infra' },
//   { term: 'creation of Users for Symposium', path: '/services-user-admin-infra' },
//   { term: 'Bulk User Creation', path: '/services-user-admin-infra' },
//   { term: 'Revalidate Account', path: '/services-user-admin-infra' },
//   { term: 'Re-validate Account', path: '/services-user-admin-infra' },
//   { term: 'Web Services', path: '/services-web-services' },
//   { term: 'Web Development', path: '/services-web-services' },
//   { term: 'Virtual Web Hosting', path: '/services-web-services' },
//   { term: 'VWeb', path: '/services-web-services' },
//   { term: 'V-Web', path: '/services-web-services' },
//   { term: 'Infrastructure Usage Policy', path: '/services-miscellaneous-policies' },
//   { term: 'Privacy Policy', path: '/services-miscellaneous-policies' },
//   { term: 'Network Access and Monitoring Policy', path: '/services-network-policy' },
//   { term: 'Track Data Usage', path: 'https://track.iitd.ac.in/', external: true },
//   { term: 'Careers', path: '/careers' },
//   { term: 'Contact', path: '/contact' },

//   // Linux
//   { term: 'Linux', path: '/services-software-linux' },
//   { term: 'Download Ubuntu', path: '/services-software-linux-ubuntu' },
//   { term: 'CentOS', path: '/services-software-linux-centos' },
//   { term: 'Download CentOS', path: '/services-software-linux-centos' },
//   { term: 'Debian', path: '/services-software-linux-debian' },
//   { term: 'Download Debian', path: '/services-software-linux-debian' },
//   { term: 'Linux Mint', path: '/services-software-linux-mint-debian-edition' },
//   { term: 'Linux Mint Debian Edition', path: '/services-software-linux-mint-debian-edition' },
//   { term: 'Gentoo Mint', path: '/services-software-linux-gentoo' },

//   // Windows
//   { term: 'Windows', path: '/services-software-windows-os' },
//   { term: 'Microsoft Office 365', path: '/services-software-windows-office-365' },
//   { term: 'Windows OS', path: '/services-software-windows-os' },
//   { term: 'Microsoft Forefront', path: '/services-software-windows-microsoft-forefront' },
//   { term: 'Microsoft .Net', path: '/services-software-windows-microsoft-net' },
//   { term: 'Office 365', path: '/services-software-windows-office-365' },
//   { term: 'Download Microsoft Office 365', path: '/services-software-windows-office-365' },
//   { term: 'Download Microsoft Office', path: '/services-software-windows-office-365' },
//   { term: 'Windows OS', path: '/services-software-windows-os' },
//   { term: 'Visual Studio', path: '/services-software-windows-os' },
//   { term: 'Microsoft.Net', path: '/services-software-windows-os' },
//   { term: 'Old/Archive Windows', path: '/services-software-windows-os' },
//   { term: 'Windows Archive', path: '/services-software-windows-os' },
//   { term: 'Activate Windows', path: '/services-software-windows-os' },
//   { term: 'Download Windows OS', path: '/services-software-windows-os' },
//   { term: 'Activate Office', path: '/services-software-windows-os' },
//   { term: 'Office 64-bit', path: '/services-software-windows-os' },
//   { term: 'Office 32-bit', path: '/services-software-windows-os' },
//   { term: 'Windows Network', path: '/services-software-windows-os' },
//   { term: 'Download Visual Studio', path: '/services-software-windows-visual-studio' },
//   { term: 'Download Microsoft Forefront', path: '/services-software-windows-microsoft-forefront' },
//   { term: 'Download Microsoft .Net', path: '/services-software-windows-microsoft-net' },

//   // Scientific
//   { term: 'Scientific', path: '/services-software-scientific' },
//   { term: 'Scientific Software', path: '/services-software-scientific' },
//   { term: 'Ansys Setup Guide', path: '/services-software-scientific' },
//   { term: 'Ansys License Server Port', path: '/services-software-scientific' },
//   { term: 'Abaqus Setup Guide', path: '/services-software-scientific' },
//   { term: 'Abaqus License Server Port', path: '/services-software-scientific' },
//   { term: 'Comsol', path: '/services-software-scientific' },
//   { term: 'Comsol Setup Guide', path: '/services-software-scientific' },
//   { term: 'Comsol License Server Port', path: '/services-software-scientific' },
//   { term: 'Materials Studio Setup Guide', path: '/services-software-scientific' },
//   { term: 'Materials Studio License Server Port', path: '/services-software-scientific' },
//   { term: 'Intel Setup Guide', path: '/services-software-scientific' },
//   { term: 'Intel License Server Port', path: '/services-software-scientific' },
//   { term: 'PGI Compilers Setup Guide', path: '/services-software-scientific' },
//   { term: 'PGI Compilers License Server Port', path: '/services-software-scientific' },
//   { term: 'Matlab Setup Guide', path: '/services-software-scientific' },
//   { term: 'Matlab License Server Port', path: '/services-software-scientific' },
//   { term: 'LabVIEW 2018', path: '/services-software-scientific' },
//   { term: 'Signal Express 2015', path: '/services-software-scientific' },
//   { term: 'Vision 2015', path: '/services-software-scientific' },

//   // User Admin
//   { term: 'Visitor Account', path: '/services-user-admin-infra-internet-access-visitor' },
//   { term: 'Revalidation', path: '/services-user-admin-revalidation' },
//   { term: 'User Admin & Infra', path: '/services-user-admin-infra' },



//   { term: 'Research Proxy', path: '/services-miscellaneous-bulk-downloads' },
//   { term: 'Download Server', path: '/services-miscellaneous-bulk-downloads' },
//   { term: 'Bulk Download', path: '/services-miscellaneous-bulk-downloads' },

//   // External Links
//   { term: 'HPC', path: 'http://supercomputing.iitd.ac.in/', external: true },
//   { term: 'Super Computing', path: 'http://supercomputing.iitd.ac.in/', external: true },
//   { term: 'High Performance Computing', path: 'http://supercomputing.iitd.ac.in/', external: true },
//   { term: 'Cloud Computing', path: 'https://baadal.iitd.ac.in/baadal', external: true },
//   { term: 'Baadal', path: 'https://baadal.iitd.ac.in/baadal', external: true },
//   { term: 'Badal', path: 'https://baadal.iitd.ac.in/baadal', external: true },
//   { term: 'Tenders', path: 'http://www.iitd.ac.in/tenders', external: true },
//   { term: 'How to?', path: '/howto' },
//   { term: 'Getting Started', path: '/getting-started' },
//   { term: 'Wired 802.1x Configuration Guide for Hostels', path: '/services-network-lan-wiredconfig' },
//   { term: 'Change kerberos password', path: 'https://userm.iitd.ernet.in/usermanage/pwchange.html', external: true },
//   { term: 'Edit your LDAP profile', path: 'https://userm.iitd.ernet.in/usermanage/profile.html', external: true }
// ];

// const SearchComponent = () => {
//   const dispatch = useDispatch();
//   const isSearchOpen = useSelector(selectIsSearchOpen);
//   const searchTriggerRef = useRef(null);
  
//   const handleSearchClick = (e) => {
//     e.preventDefault();
//     dispatch(openSearch());
//   };

//   return (
//     <>
//       {/* <li className="nav-item">
//         <a
//           className="nav-link search-link p-0"
//           href="#"
//           ref={searchTriggerRef}
//           onClick={handleSearchClick}
//           style={{ 
//     transform: 'rotate(40deg)', 
//     transition: 'transform 0.2s ease',
//     fontSize: '18px',
//     // margin: '0 10px',
//     color: '#333'
//   }} 
//         >
//           <FaSearch className="search-icon-trigger pulse-animation" />
//         </a>
//       </li> */}
      
//       <SearchModal searchData={searchData} />
//     </>
//   );
// };

// const SearchModal = ({ searchData }) => {
//   const dispatch = useDispatch();
//   const isOpen = useSelector(selectIsSearchOpen);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [isClosing, setIsClosing] = useState(false);
//   const [filteredResults, setFilteredResults] = useState([]);
//   const modalRef = useRef(null);
//   const inputRef = useRef(null);
  
//   const closeModal = () => {
//     setIsClosing(true);
//     setTimeout(() => {
//       dispatch(closeSearch());
//       setSearchQuery('');
//       setIsClosing(false);
//     }, 500);
//   };
  
//   const handleSearch = (e) => {
//     const query = e.target.value;
//     setSearchQuery(query);
    
//     if (query.length > 0) {
//       const results = searchData.filter(item =>
//         item.term.toLowerCase().includes(query.toLowerCase())
//       );
//       setFilteredResults(results);
//     } else {
//       setFilteredResults([]);
//     }
//   };
  
//   // Handle click on search result
//   const handleResultClick = () => {
//     closeModal();
//   };

//   // Update body overflow style when modal opens or closes
//   useEffect(() => {
//     if (isOpen) {
//       document.body.style.overflow = 'hidden';
//       setTimeout(() => {
//         if (inputRef.current) {
//           inputRef.current.focus();
//         }
//       }, 300);
//     } else {
//       document.body.style.overflow = 'auto';
//     }
//   }, [isOpen]);
  
//   // Close modal on Escape key press
//   useEffect(() => {
//     const handleEscKey = (e) => {
//       if (e.key === 'Escape' && isOpen && !isClosing) {
//         closeModal();
//       }
//     };
    
//     document.addEventListener('keydown', handleEscKey);
    
//     return () => {
//       document.removeEventListener('keydown', handleEscKey);
//     };
//   }, [isOpen, isClosing]);

//   // Click outside to close
//   useEffect(() => {
//     const handleOutsideClick = (e) => {
//       if (modalRef.current && !modalRef.current.contains(e.target) && !isClosing) {
//         closeModal();
//       }
//     };

//     if (isOpen) {
//       setTimeout(() => {
//         document.addEventListener('mousedown', handleOutsideClick);
//       }, 300);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleOutsideClick);
//     };
//   }, [isOpen, isClosing]);
  
//   if (!isOpen && !isClosing) return null;
  
//   return (
//     <div className={`search-modal-overlay ${isClosing ? 'closing' : ''}`}>
//       <div className="search-modal-background"></div>
//       <div className="search-modal-content" ref={modalRef}>
//         <button
//           className="close-button"
//           onClick={closeModal}
//           aria-label="Close search"
//         >
//           <FaTimes className="close-icon" />
//         </button>
        
//         <div className="search-container">
//           <div className="search-header">
//             <h1 className="search-title">Computer Service Center</h1>
//             <div className="search-subtitle">Find what you need in seconds</div>
//           </div>
          
//           <div className="search-input-wrapper">
//             <FaSearch className="search-input-icon" />
//             <input
//               type="text"
//               className="search-input"
//               placeholder="Type to search..."
//               value={searchQuery}
//               onChange={handleSearch}
//               ref={inputRef}
//             />
//             {searchQuery && (
//               <button 
//                 className="clear-search" 
//                 onClick={() => {
//                   setSearchQuery('');
//                   setFilteredResults([]);
//                 }}
//                 aria-label="Clear search"
//               >
//                 <FaTimes />
//               </button>
//             )}
//           </div>
          
//           {searchQuery && (
//             <div className="search-results">
//               <div className="search-results-header">
//                 <span className="results-title">Search Results</span>
//                 <span className="results-count">
//                   {filteredResults.length} {filteredResults.length === 1 ? 'result' : 'results'}
//                 </span>
//               </div>
              
//               <div className="results-list">
//                 {filteredResults.length > 0 ? (
//                   filteredResults.map((result, index) => (
//                     result.external ? (
//                       <a
//                         key={index}
//                         href={result.path}
//                         className="result-item"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={handleResultClick}
//                       >
//                         <div className="result-term">{result.term}</div>
//                         <div className="result-path">{result.path}</div>
//                       </a>
//                     ) : (
//                       <Link
//                         key={index}
//                         to={result.path}
//                         className="result-item"
//                         onClick={handleResultClick}
//                       >
//                         <div className="result-term">{result.term}</div>
//                         {/* <div className="result-path">{result.path}</div> */}
//                       </Link>
//                     )
//                   ))
//                 ) : (
//                   <div className="no-results-message">
//                     <div className="no-results-icon">
//                       <FaSearch />
//                     </div>
//                     <p>No results found for "<strong>{searchQuery}</strong>"</p>
//                     <p className="no-results-suggestion">Try different keywords or check spelling</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
          
//           {!searchQuery && (
//             <div className="search-suggestions">
//               <h3 className="suggestion-title">Popular Searches</h3>
//               <div className="suggestion-tags">
//                 <Link to="/services-network" className="suggestion-tag" onClick={closeModal}>
//                   Network
//                 </Link>
//                 <a 
//                   href="https://supercomputing.iitd.ac.in/" 
//                   className="suggestion-tag" 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                   onClick={closeModal}
//                 >
//                   HPC
//                 </a>
//                 <Link to="/services-erp" className="suggestion-tag" onClick={closeModal}>
//                   ERP
//                 </Link>
//                 <a 
//                   href="https://userm.iitd.ac.in/usermanage/pwchange.html" 
//                   className="suggestion-tag" 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                   onClick={closeModal}
//                 >
//                   Change Kerberos Password
//                 </a>
//                 <Link to="/setup-vpn" className="suggestion-tag" onClick={closeModal}>
//                   Setup VPN
//                 </Link>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SearchComponent;

import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { openSearch, closeSearch, selectIsSearchOpen } from '../redux/headerSlice';
import './SearchModal.css';
import { Base_Url } from '../config';

// Search Button Component
const SearchComponent = () => {
  const dispatch = useDispatch();
  const isSearchOpen = useSelector(selectIsSearchOpen);
  
  const handleSearchClick = (e) => {
    e.preventDefault();
    dispatch(openSearch());
  };

  return (
    <>
      {/* Search Button - UNCOMMENT IF NEEDED */}
      {/* <button onClick={handleSearchClick} className="search-button">
        <FaSearch />
      </button> */}
      
      {/* Search Modal - ONLY ONE INSTANCE */}
      {isSearchOpen && <SearchModal />}
    </>
  );
};

// Search Modal Component
const SearchModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsSearchOpen);
  const [searchQuery, setSearchQuery] = useState('');
  const [isClosing, setIsClosing] = useState(false);
  const [allSearchTerms, setAllSearchTerms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef(null);
  const inputRef = useRef(null);
  
  // Static popular searches
  const staticPopularSearches = useMemo(() => [
    { term: 'Network', path: '/services-network' },
    { term: 'HPC', path: 'https://supercomputing.iitd.ac.in/', external: true },
    { term: 'ERP', path: '/services-erp' },
    { term: 'Change Kerberos Password', path: 'https://userm.iitd.ac.in/usermanage/pwchange.html', external: true },
    { term: 'Setup VPN', path: '/setup-vpn' }
  ], []);

  // Fetch all search terms with duplicate removal
  const fetchAllSearchTerms = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${Base_Url}/terms`);
      if (response.ok) {
        const data = await response.json();
        
        // Remove duplicates based on term + path combination
        const uniqueTerms = removeDuplicates(data.terms || []);
        setAllSearchTerms(uniqueTerms);
      } else {
        console.error('Failed to fetch search terms');
        setAllSearchTerms([]);
      }
    } catch (error) {
      console.error('Error fetching search terms:', error);
      setAllSearchTerms([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Function to remove duplicates
  const removeDuplicates = (terms) => {
    const seen = new Set();
    return terms.filter(term => {
      const identifier = `${term.term}-${term.path}`.toLowerCase();
      if (seen.has(identifier)) {
        return false;
      }
      seen.add(identifier);
      return true;
    });
  };

  // Frontend filtering logic - IMPROVED WITH DUPLICATE PROTECTION
  const filteredResults = useMemo(() => {
    if (!searchQuery.trim()) return [];

    const query = searchQuery.toLowerCase().trim();
    
    // Use Set to track already included results
    const includedIdentifiers = new Set();
    const results = [];

    for (const item of allSearchTerms) {
      if (!item.term) continue;
      
      const term = item.term.toLowerCase();
      const identifier = `${term}-${item.path}`.toLowerCase();
      
      // Skip if already included
      if (includedIdentifiers.has(identifier)) continue;
      
      // Exact match (highest priority)
      if (term === query) {
        results.push({ ...item, matchScore: 100 });
        includedIdentifiers.add(identifier);
        continue;
      }
      
      // Starts with query
      if (term.startsWith(query)) {
        results.push({ ...item, matchScore: 80 });
        includedIdentifiers.add(identifier);
        continue;
      }
      
      // Contains query
      if (term.includes(query)) {
        results.push({ ...item, matchScore: 60 });
        includedIdentifiers.add(identifier);
        continue;
      }
      
      // Word boundary matching
      const words = term.split(/\s+/);
      if (words.some(word => word.startsWith(query))) {
        results.push({ ...item, matchScore: 40 });
        includedIdentifiers.add(identifier);
      }
    }
    
    // Sort by match score and priority
    return results
      .sort((a, b) => {
        // First by match score (higher first)
        if (b.matchScore !== a.matchScore) {
          return b.matchScore - a.matchScore;
        }
        
        // Then by priority (higher first)
        if (a.priority !== b.priority) {
          return (b.priority || 0) - (a.priority || 0);
        }
        
        // Then by term length (shorter first)
        return a.term.length - b.term.length;
      })
      .slice(0, 20) // Limit to 20 results
      .map(item => {
        // Remove matchScore before returning
        const { matchScore, ...cleanItem } = item;
        return cleanItem;
      });
  }, [searchQuery, allSearchTerms]);

  const closeModal = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      dispatch(closeSearch());
      setSearchQuery('');
      setAllSearchTerms([]);
      setIsClosing(false);
    }, 300);
  }, [dispatch]);

  const handleSearch = useCallback((e) => {
    setSearchQuery(e.target.value);
  }, []);
  
  const handleResultClick = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const handlePopularSearchClick = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // Debug useEffect
  // useEffect(() => {
  //   console.log('Search modal state:', { 
  //     isOpen, 
  //     searchQuery, 
  //     allSearchTermsCount: allSearchTerms.length,
  //     filteredResultsCount: filteredResults.length 
  //   });
  // }, [isOpen, searchQuery, allSearchTerms, filteredResults]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      // Fetch terms when modal opens
      fetchAllSearchTerms();
      
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, fetchAllSearchTerms]);

  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && isOpen && !isClosing) {
        closeModal();
      }
    };
    
    document.addEventListener('keydown', handleEscKey);
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, isClosing, closeModal]);

  if (!isOpen && !isClosing) return null;
  
  return (
    <div className={`search-modal-overlay ${isClosing ? 'closing' : ''}`}>
      <div className="search-modal-background" onClick={closeModal}></div>
      <div className="search-modal-content" ref={modalRef}>
        <button
          className="close-button"
          onClick={closeModal}
          aria-label="Close search"
        >
          <FaTimes className="close-icon" />
        </button>
        
        <div className="search-container">
          <div className="search-header">
            <h1 className="search-title">Computer Service Center</h1>
            <div className="search-subtitle">Find what you need in seconds</div>
          </div>
          
          <div className="search-input-wrapper">
            <input
              type="text"
              className="search-input"
              placeholder="Type to search..."
              value={searchQuery}
              onChange={handleSearch}
              ref={inputRef}
              disabled={isLoading}
            />
            {isLoading && (
              <div className="search-loading">
                <div className="loading-spinner"></div>
              </div>
            )}
            {searchQuery && !isLoading && (
              <button 
                className="clear-search" 
                onClick={clearSearch}
                aria-label="Clear search"
              >
                <FaTimes />
              </button>
            )}
          </div>
          
          {searchQuery ? (
            <div className="search-results">
              <div className="search-results-header">
                <span className="results-title">Search Results</span>
                <span className="results-count">
                  {isLoading ? 'Loading...' : `${filteredResults.length} ${filteredResults.length === 1 ? 'result' : 'results'}`}
                </span>
              </div>
              
              <div className="results-list">
                {!isLoading && filteredResults.length > 0 ? (
                  filteredResults.map((result, index) => (
                    result.is_external ? (
                      <a
                        key={`result-${result.id || result.term}-${index}`}
                        href={result.path}
                        className="result-item"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleResultClick}
                      >
                        <div className="result-term">{result.term}</div>
                        {result.category && (
                          <div className="result-category">{result.category}</div>
                        )}
                      </a>
                    ) : (
                      <Link
                        key={`result-${result.id || result.term}-${index}`}
                        to={result.path}
                        className="result-item"
                        onClick={handleResultClick}
                      >
                        <div className="result-term">{result.term}</div>
                        {result.category && (
                          <div className="result-category">{result.category}</div>
                        )}
                      </Link>
                    )
                  ))
                ) : !isLoading && searchQuery ? (
                  <div className="no-results-message">
                    <div className="no-results-icon">
                      {/* <FaSearch /> */}
                    </div>
                    <p>No results found for "<strong>{searchQuery}</strong>"</p>
                    <p className="no-results-suggestion">Try different keywords or check spelling</p>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="search-suggestions">
              <h3 className="suggestion-title">Popular Searches</h3>
              <div className="suggestion-tags">
                {staticPopularSearches.map((popularItem, index) => (
                  popularItem.external ? (
                    <a
                      key={`popular-${popularItem.term}-${index}`}
                      href={popularItem.path}
                      className="suggestion-tag"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={handlePopularSearchClick}
                    >
                      {popularItem.term}
                    </a>
                  ) : (
                    <Link
                      key={`popular-${popularItem.term}-${index}`}
                      to={popularItem.path}
                      className="suggestion-tag"
                      onClick={handlePopularSearchClick}
                    >
                      {popularItem.term}
                    </Link>
                  )
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;